var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neo__image-loading__container",class:_vm.customClass},[_c('img',{staticClass:"image",class:_vm.load,staticStyle:{"background-position":"50% 50%","object-position":"50% 50%"},attrs:{"width":_vm.width ? _vm.width : null,"height":_vm.height ? _vm.height : null,"alt":_vm.alt,"aria-label":_vm.alt,"data-src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }